import React, { useState, useEffect } from 'react';
import CategoryTable from '../componenents/Tables/CategoryTable';
import { gql, useQuery } from '@apollo/client';
import { message, Spin } from 'antd';
import UserTable from '../componenents/Tables/UserTable';
import { useNavigate } from 'react-router-dom';

// GraphQL query to fetch categories
const GET_CATEGORIES = gql`
  query  {
    listCategorys{
     id
      name
      createdAt
    }
     
    
  }
`;


const UserPage = () => {
   const navigate = useNavigate();
   // Redirect if the user does not have a valid role
   const roleType = localStorage.getItem('roleType'); // Get role type from localStorage
  useEffect(() => {
    if (!roleType || (roleType !== 'ADMIN')) {
      navigate('/admin/home'); // Redirect to home if role is invalid
    }
  }, [roleType, navigate]);


  return (
    <div>
      <h1>List Of Users</h1>
      <UserTable  />
    </div>
  );
};

export default UserPage;
